import styles from "./Layout.module.css"

interface Layout {
  children: JSX.Element
}

export function Layout({ children }: Layout) {
  return <main className={styles.component}>{children}</main>
}
